import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const SubProductosTable = ({
    subproductos,
    carro,
    currentIndex,
}) => {
    return (
        <>
            <h5>{`Subproductos de ${carro[currentIndex].nombre_producto}`}</h5>

            <DataTable
                value={subproductos}
                className="p-datatable-gridlines"
                showGridlines
                dataKey="id"
                emptyMessage="No tiene subproductos asociados"
            >
                <Column field="descripcion" header="Subproducto" sortable />
                <Column field="tipo_descripcion" header="Tipo SubProducto" sortable />
                <Column
                    field="incluido"
                    header="Tipo"
                    body={(rowData) =>
                        rowData.incluido ? "Incluido" : "Adicional"
                    }
                    sortable
                />
            </DataTable>
        </>
    );
};

export default SubProductosTable;
